import { useRef, memo } from 'react';
import type { AriaTextFieldProps } from 'react-aria';
import { useTextField } from 'react-aria';



export interface TextFieldProps extends AriaTextFieldProps {
	required?: boolean,
	rounded?: boolean,
}


const TextField = (props: TextFieldProps) => {
	const { required = false, rounded = false, ...otherProps } = props;
	
	let ref = useRef<HTMLInputElement>(null);
	
	let { labelProps, inputProps, descriptionProps, errorMessageProps } = useTextField(otherProps, ref);

	return (
		<div className='component-text-field'>

			<label {...labelProps} className='text-field-label'>
				{props.label} {required ? <span>*</span> : ''}
			</label>
			
			<input {...inputProps} ref={ref} className={`text-field-input${rounded ? ' rounded' : ''}`} />
		
			{props.errorMessage && typeof props.errorMessage === 'string' &&
				<div {...errorMessageProps} className={`text-field-error${rounded ? ' rounded' : ''}`}>
					{props.errorMessage}
				</div>}

			{props.description && 
				<div {...descriptionProps} className='text-field-description'>
					{props.description}
				</div>}
		</div>
	)
}


export default memo(TextField);